import useInvoicesQuery from 'hooks/useInvoicesQuery';
import { useCallback, useEffect, useMemo, useState } from 'react';

const useInvoiceList = (
  filterParams: Record<string, string>,
  enabled: boolean,
) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const params = useMemo(
    () => ({
      page: currentPage - 1,
      size: pageSize,
      ...filterParams,
    }),
    [currentPage, pageSize, filterParams],
  );

  const { data, totalCount, isLoading } = useInvoicesQuery({ params, enabled });

  const handlePageChange = useCallback((page: number, size: number) => {
    setCurrentPage(page);
    setPageSize(size);
  }, []);

  useEffect(() => {
    setCurrentPage(1);
    setPageSize(10);
  }, [filterParams]);

  return {
    data,
    totalCount,
    isLoading,
    handlePageChange,
    currentPage,
    pageSize,
  };
};

export default useInvoiceList;
